import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    BaseStationAdd,
    BaseStationEdit,
    BaseStationList,
    BaseStationParams, RadioAddParams,
    RadioData,
} from '@app/interfaces/rm/base-station';
import { ResourceInstancesFields } from '@app/interfaces/rm/resource-instances';
import { OptionsParams, SelectOption } from '@app/interfaces/sys/dict';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BaseStationService {
    private baseUrl = environment.api.services.rm + '/base-stations';

    constructor(private http: HttpClient) {}

    async find(params: BaseStationParams): Promise<BaseStationList> {
        return lastValueFrom(this.http.get<BaseStationList>(`${this.baseUrl}`, {
            params: Object.assign(params),
        }));
    }

    async options(params?: OptionsParams): Promise<SelectOption[]> {
        return lastValueFrom(this.http.get<SelectOption[]>(`${this.baseUrl}/all-options`, {
            params: params ? Object.assign(params) : {}
        }));
    }

    async baseStationCreate(option: BaseStationAdd): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}`, option));
    }

    async one(option: { id: number }): Promise<any> {
        return lastValueFrom(this.http.get<any>(`${this.baseUrl}/one`, {
            params: Object.assign(option),
        }));
    }

    async edit(option: BaseStationEdit): Promise<void> {
        return lastValueFrom(this.http.put<void>(`${this.baseUrl}`, option));
    }

    async baseStationDelete(id: number): Promise<void> {
        return lastValueFrom(this.http.delete<void>(`${this.baseUrl}`, {
            params: Object.assign({ id }),
        }));
    }

    getBaseStationRadioParams(radioList: RadioData[]): RadioAddParams[] {
        const radios = radioList.map((item) => {
            let radioFields: ResourceInstancesFields[] = [];
            if (item.resourceInstance && item.resourceInstance.fields.length > 0) {
                radioFields = item.resourceInstance.fields?.map(radioFieldItem => {
                    const { value, resourceDefinitionFieldId } = radioFieldItem;
                    return {
                        resourceDefinitionFieldId,
                        value
                    };
                });
            }
            return {
                ...item,
                locationId: item.locationId && item.locationId.length > 0 ? item.locationId[item.locationId.length - 1] : null,
                fields: radioFields
            };
        });
        return radios as RadioAddParams[];
    }
}
